<button
  [type]="type"
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  [hidden]="hidden"
  (click)="onClick($event)"
>
  <ng-container *ngIf="loading; else content">
    <i class="fa fa-spinner fa-spin me-1" aria-hidden="true"></i>
    <ng-content select="[loading-text]"></ng-content>
  </ng-container>

  <ng-template #content>
    <i *ngIf="icon" [class]="icon + ' me-1'" aria-hidden="true"></i>
    <ng-content></ng-content>
  </ng-template>
</button>
